import { colours } from '../_styleguide/_colours';
import { breakpoints } from '../_styleguide/_breakpoints';
var HtmlLegendDots = /** @class */ (function () {
    function HtmlLegendDots(ctrlr) {
        this.ctrlr = ctrlr;
        this.draw();
    }
    HtmlLegendDots.prototype.draw = function () {
        var _this = this;
        var mapping = this.ctrlr.mapping ? this.ctrlr.mapping.parameters : this.ctrlr.graphObject.mapping;
        var legend = document.createElement('div');
        legend.classList.add('legend');
        legend.style.display = 'flex';
        legend.style.flexDirection = window.innerWidth < breakpoints.md ? 'column' : 'row';
        legend.style.paddingLeft = window.innerWidth < breakpoints.md ? this.ctrlr.config.padding.left + 'px' : '0';
        legend.style.justifyContent = 'center';
        legend.style.width = '100%';
        mapping[0].forEach(function (map, i) {
            var item = _this.createDiv();
            item.appendChild(_this.createCircle(map));
            item.appendChild(_this.createLabel(map));
            legend.appendChild(item);
        });
        this.ctrlr.element.insertBefore(legend, this.ctrlr.element.querySelector('svg'));
    };
    HtmlLegendDots.prototype.createDiv = function () {
        var item = document.createElement('div');
        item.style.display = 'flex';
        item.style.flexDirection = 'row';
        item.style.alignItems = 'center';
        item.style.marginRight = (window.innerWidth > 700) ? '2rem' : '.5rem';
        return item;
    };
    HtmlLegendDots.prototype.createCircle = function (map) {
        var circle = document.createElement('span');
        circle.style.width = (window.innerWidth > 700) ? '.75rem' : '.5rem';
        circle.style.height = (window.innerWidth > 700) ? '.75rem' : '.5rem';
        circle.style.borderRadius = '50%';
        circle.style.marginRight = (window.innerWidth > 700) ? '.5rem' : '.25rem';
        circle.style.display = 'inline-block';
        circle.style.background = colours[map['colour']][0];
        return circle;
    };
    HtmlLegendDots.prototype.createLabel = function (map) {
        var label = document.createElement('span');
        label.style.fontFamily = "NotoSans Regular";
        label.style.fontSize = (window.innerWidth > 700) ? '.825rem' : '.71em';
        label.innerText = map['label'];
        return label;
    };
    return HtmlLegendDots;
}());
export default HtmlLegendDots;
